import { getSelectedInstitutionId } from '@/lib/api/client'
import type { AuthGuard } from '@/lib/jwt'

/** Resolve instituição ativa para pedidos (admin pode depender só do localStorage). */
export function resolvePedidosInstitutionId(
  guard: AuthGuard | null,
  institutionId: string | null
): string | null {
  if (guard !== 'admin') return institutionId
  return institutionId ?? getSelectedInstitutionId()
}

export function canChangePedidoStatus(
  guard: AuthGuard | null,
  isCollaborator: boolean,
  institutionId: string | null
): boolean {
  const resolvedInstitutionId = resolvePedidosInstitutionId(guard, institutionId)
  const isAdminWithoutInstitution =
    guard === 'admin' && resolvedInstitutionId === null
  return (
    (guard === 'institution' || guard === 'admin') &&
    !isCollaborator &&
    !isAdminWithoutInstitution
  )
}
